import { request } from './client';

export const apiGetAboutPage = () => request('/site-content/page/about');

export const apiGetContactPage = () => request('/site-content/page/contact');

export const apiGetSiteSection = (section) => request(`/site-content/${section}`);

export const apiGetSitePage = (prefix) => request(`/site-content/page/${prefix}`);

export const apiGetPageVisibility = () => request('/site-content/pages/visibility');
export const apiGetHomeSectionVisibility = () => request('/site-content/home/visibility');
